import React from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Grid, CircularProgress } from '@mui/material';
import { Card, ExpandingText } from '@totalsoft/rocket-ui';
import { LogProperty } from 'features/logs/components/LogStyles';

const LogDetailComponent = ({ log, loading }) => {
  const { t } = useTranslation();

  return loading ? (
    <Grid container spacing={2} justifyContent='center' alignItems='center' id='logDetail'>
      <Grid item>
        <CircularProgress />
      </Grid>
    </Grid>
  ) : log.id ? (
    <Card title={`${log.level}(Id: ${log.id})`}>
      <Grid container spacing={1} className='pt-2'>
        <Grid item xs={12} md={6}>
          <div>
            <strong>{t('Logs.CorrelationId')}:</strong> <pre style={{ display: 'inline' }}>{log.correlationId || 'N/A'}</pre>
          </div>
        </Grid>

        <Grid item xs={12} md={6}>
          <div>
            <strong>{t('Logs.TimeStamp')}:</strong> <pre style={{ display: 'inline' }}>{log.timeStamp}</pre>
          </div>
        </Grid>

        {log.exception ? (
          <Grid item xs={12}>
            <div>
              <strong>{t('Logs.Exception')}:</strong>
              <LogProperty>
                <ExpandingText text={log.exception} />
              </LogProperty>
            </div>
          </Grid>
        ) : (
          ''
        )}

        {log.logEvent !== '' && log.logEvent ? (
          <Grid item xs={12}>
            <div>
              <strong>{t('Logs.LogEvent')}:</strong>
              <LogProperty>
                <ExpandingText text={log.logEvent} />
              </LogProperty>
            </div>
          </Grid>
        ) : null}

        {log.message ? (
          <Grid item xs={12}>
            <div>
              <strong>{t('Logs.Message')}:</strong>
              <LogProperty>
                <ExpandingText text={log.message} />
              </LogProperty>
            </div>
          </Grid>
        ) : null}
      </Grid>
    </Card>
  ) : (
    <div></div>
  );
};

LogDetailComponent.propTypes = {
  log: PropTypes.object,
  loading: PropTypes.bool
};

export default LogDetailComponent;
